import React from 'react';

function Header() {
    return (<header>Level 400 Sample Solution - React</header>);
}

export default Header;